import { Box, Button, CircularProgress,Stack, Typography } from '@mui/material'
import cls from 'classnames'
import Image from 'next/image'
import { useQRCode } from 'next-qrcode'
import { memo, MouseEventHandler, useCallback, useState } from 'react'

import useTrans from '@/hooks/useTrans'
import { IconName, staticImportIcon } from '@/utils/static-import-icon'

const AddressWithCode = ({ address, loading }: { address: string; loading: boolean }) => {
  const trans = useTrans()
  const { Canvas } = useQRCode()
  const [isCopied, setIsCopied] = useState(false)

  const handleClickCopy: MouseEventHandler<HTMLButtonElement> = useCallback((evt) => {
    evt.stopPropagation()
    setIsCopied(true)
    navigator.clipboard.writeText(address)

    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }, [address])

  if (!address) return null

  return (
    <Stack>
      <Typography className="text-sm pb-4 pt-2 text-center">{trans.wrapped_token.to_address_below}</Typography>
      <Box display="flex" justifyContent="center" className="relative">
        <Box className={cls('w-[172px] h-[172px] overflow-hidden rounded-[8px]', { 'opacity-50': loading })}>
          <Canvas
            text={address}
            options={{
              level: 'M',
              scale: 0,
              width: 172,
              margin: 2,
            }}
          />
        </Box>
        {loading && (
            <Box className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[1]">
              <CircularProgress size="3rem" />
            </Box>
          )}
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="rounded-[8px] border border-[#3A3F5D] border-solid bg-[#060814] p-1 min-h-[44px] mt-2"
      >
        <Typography className="text-sm p-1 break-all flex-1">{address}</Typography>
        <Button
          onClick={handleClickCopy}
          data-testid="btn-copy"
          className="normal-case text-sm font-semibold color-[#E7E8EB] gap-2 rounded-[4px] bg-[#1A2330] whitespace-nowrap"
        >
          <Image
            src={staticImportIcon(IconName.COPY)}
            alt="copy"
            width={20}
            className="cursor-pointer min-w-[20px]"
          />
          {isCopied ? trans.common.copied : trans.common.copy}
        </Button>
      </Box>
    </Stack>
  )
}

export default memo(AddressWithCode)
